import React from 'react';

import { useAppSelector } from '../../hooks';
import { useGetConfirmationReviewVariant } from '../../hooks/useGetConfirmationReviewVariant';
import { selectIsStaff } from '../../selectors/selectAppDetails';
import { FeefoPanel } from './FeefoPanel';
import { ProductReviewPanel } from './ProductReviewPanel';

export const ProductRatingPanel = () => {
  const isStaff = useAppSelector(selectIsStaff);
  const reviewVariant = useGetConfirmationReviewVariant();
  if (isStaff) return null;
  switch (reviewVariant) {
    case 'feefo':
      return <FeefoPanel />;
    case 'productReview':
      return <ProductReviewPanel />;
    default:
      return null;
  }
};
